let API_URL = "https://manage.qsilaunchpad.com/api";
let STRAPI_URL = "https://manage.qsilaunchpad.com"

// let API_URL = "http://localhost:1337/api";
// let STRAPI_URL = "http://localhost:1337"

let API = {api: API_URL, strapi: STRAPI_URL}
export default API